import axios from "axios";
import { config } from "../config/config";
import history from "./history";
import i18next from "../plugins/i18nextPlugin";
import { toast } from "react-toastify";

const InstanceAxios = axios.create({
  baseURL: config.apiUrl
});
export function setAuthToken(token) {
  axios.defaults.headers.common = {
      Authorization: `Bearer ${token}`,
     // "x-arka-user-id": 26033,
     // "x-arka-societe-id":6968
  };
}
InstanceAxios.interceptors.response.use(
  response => response,
  error => {
    if (
      !error.response ||
      !error.response.status ||
      error.response.status === 500
    ) {
      toast.error(i18next.t("error.unknown"));
      return Promise.reject();
    } else if (error.response.status === 401) {
      toast.error(i18next.t("error.authexpired"));
      history.push("/login");
      return Promise.reject();
    }

    return Promise.reject(error);
  }
);
export default InstanceAxios;



// WEBPACK FOOTER //
// ./src/plugins/axiosInstance.ts